import house1 from "./DSC7685.webp";
import house2 from "./DSC7692.webp";
import house3 from "./DSC7702.webp";
import house4 from "./domek.webp";
import house5 from "./DSC_8866-1.webp";
import house6 from "./DSC_8877.webp";
import house7 from "./DSC_8882.webp";
import house8 from "./domek_wiatr_niedzica1.webp";
import house9 from "./domek_wiatr_niedzica2.webp";
import house10 from "./domek_woda_niedzica2.webp";
import house11 from "./domek_wiatr.webp"
import house12 from "./domek_woda_niedzica5.webp";
import house13 from "./domek_woda_niedzica6.webp";
import house14 from "./domek_woda_niedzica7.webp";
import house15 from "./domek_woda_niedzica8.webp";
import house16 from "./domek_woda_niedzica9.webp";

export const housesImages = [
    { src: house1, altKey: "1" },
    { src: house2, altKey: "2" },
    { src: house3, altKey: "3" },
    { src: house4, altKey: "4" },
    { src: house5, altKey: "5" },
    { src: house6, altKey: "6" },
    { src: house7, altKey: "7" },
    { src: house8, altKey: "8" },
    { src: house9, altKey: "9" },
    { src: house10, altKey: "10" },
    { src: house11, altKey: "11" },
    { src: house12, altKey: "12" },
    { src: house13, altKey: "13" },
    { src: house14, altKey: "14" },
    { src: house15, altKey: "15" },
    { src: house16, altKey: "16" }
];